<template>
<div class="chapter">
<div class="inner_page">
<a id="page_1"></a>
<div class="sidebar5">
<p class="half">PEPPERCORN</p>
<p class="half1">HIS LIFE AND LOCOMOTIVES<a id="page_2"></a></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 01_Halftitle.vue?66fa5e54